import {Create} from './Create';

export const CreativesGroup = {
  Create,
};
